(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-slider"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    $('.home-slider').slick({
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: true,
      autoplaySpeed: 7000,
      infinite: true,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-press"] && !Shopify.designMode) return;
  try {
    
class PressQuotes {
  constructor(container) {
    this.container = container;
    this.slider = container.querySelector('[data-quotes-slider]');
    this.quotes = container.querySelectorAll('.press-quote');
    this.logos = container.querySelectorAll('.press-quote__logo');
    this.autoplay = container.dataset.autoplay === 'true';
    this.duration = parseInt(container.dataset.duration, 10);
    
    this.currentIndex = 0;
    
    if (this.quotes.length > 1) {
      this.init();
    }
  }

  init() {
    // Add click event handlers to logos
    this.logos.forEach((logo, index) => {
      logo.addEventListener('click', () => this.goToQuote(index));
    });

    // Show the first quote
    this.quotes[0].classList.add('active');

    // Add active class to the first logo
    this.logos[0].classList.add('active');

    if (this.autoplay) {
      this.startAutoplay();
    }

    // Show slider once initialized
    this.slider.classList.add('is-ready');
  }

  startAutoplay() {
    this.autoplayInterval = setInterval(() => {
      this.goToNext();
    }, this.duration);
  }

  goToQuote(index) {
    // Hide all quotes
    this.quotes.forEach((quote) => {
      quote.classList.remove('active');
    });

    // Show the selected quote
    this.quotes[index].classList.add('active');

    // Remove active class from all logos
    this.logos.forEach((logo) => {
      logo.classList.remove('active');
    });

    // Add active class to the selected logo
    this.logos[index].classList.add('active');

    // Update current index
    this.currentIndex = index;
  }

  goToNext() {
    const nextIndex = (this.currentIndex + 1) % this.quotes.length;
    this.goToQuote(nextIndex);
  }

  destroy() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }
}

// Initialize on section load
document.addEventListener('shopify:section:load', (event) => {
  const container = event.target.querySelector('[data-press-quotes]');
  if (container) {
    new PressQuotes(container);
  }
});

// Initialize on page load
document.querySelectorAll('[data-press-quotes]').forEach((container) => {
  new PressQuotes(container);
});

  } catch(e) { console.error(e); }
})();
})();
